import { render, staticRenderFns } from "./BusinessList.vue?vue&type=template&id=662ba380&scoped=true&"
import script from "./BusinessList.vue?vue&type=script&lang=js&"
export * from "./BusinessList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessList.vue?vue&type=style&index=0&id=662ba380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662ba380",
  null
  
)

export default component.exports